import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["admin-container", { mobile: _ctx.isMobile || _ctx.isTablet }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Dropdown, {
        openOnHover: "",
        options: _ctx.options,
        modelValue: _ctx.selected,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, { type: "outlined" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Menu", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["options", "modelValue"])
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (!_ctx.isMobile && !_ctx.isTablet)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
      : (_openBlock(), _createBlock(_component_MobileFooter, { key: 1 }))
  ], 2))
}